import React, { useState } from 'react';
import { QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { useRemoteConfiguration } from './hooks/useRemoteConfiguration';
import { getQueryClient } from './client';

export const QueryProvider = ({ children, clients }) => {
    // Create client lazily in component to ensure remote config can be applied first
    const [queryClient] = useState(() => getQueryClient());
    const { isFinished } = useRemoteConfiguration(queryClient, clients?.appSettingsDataClient);

    if (!isFinished) {
        return null;
    }

    return (
        <QueryClientProvider client={queryClient}>
            {children}
            <ReactQueryDevtools initialIsOpen />
        </QueryClientProvider>
    );
};
